<template>
	<v-container class="mt-4  pr-4">
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Pagos</span>
	  		    <v-spacer></v-spacer>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon  small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon  small>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>

	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="6" lg="5">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
                  single-line
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="usuarios"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >

							  	<template v-slot:item.costo="{ item }">
							    	<span>${{item.costo}}.00</span>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="error" 
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idusuarios }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="editedItem.nombre_completo"
            label="Nombre completo"
            filled
            dense
          ></v-text-field>

          <v-text-field
            v-model="editedItem.edad"
            label="Edad"
            type="number"
            filled
            dense
          ></v-text-field>

          <v-select
            :items="[{id:1,text:'ADMINISTRADOR'},{id:2, text:'COACH'},{id:3, text:'ALUMNO'}]"
            v-model="editedItem.tipo_usuario"
            label="tipo_usuario"
            item-text="text"
            item-value="id"
            filled
            dense
          ></v-select>

          <v-text-field
            v-model="editedItem.telefono"
            label="Teléfono"
            type="number"
            filled
            dense
          ></v-text-field>

          <v-text-field
            v-model="editedItem.correo"
            label="Usuario"
            filled
            dense
            :readonly="editedIndex > -1 ? true : false"
          ></v-text-field>

          <v-text-field
            v-model="editedItem.fecha_nacimiento"
            label="Fecha nacimiento"
            type="date"
            filled
            dense
          ></v-text-field>

          <v-text-field
            v-model="editedItem.pass"
            label="Password"
            type="password"
            filled
            dense
            :readonly="editedIndex > -1 ? true : false"
          ></v-text-field>

        	<v-switch 
        		label="¿Activo Si/No?"
            hide-details
        		v-model="editedItem.estatus">
        	</v-switch>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            small
            dark
            @click="close"
          >
          	<v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          
          <v-spacer></v-spacer>

          <v-btn
            color="green"
            dark
            small
            tile
            @click="save"
          >
          	<v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el dato?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idusuarios:0,
				nombre_completo:'',
        apellidos:'',
        edad:'',
        correo:'',
        pass:'',
        tipo_usuario:0,
        fecha_nacimiento: null,
        telefono:'',
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idusuarios:0,
				nombre_completo:'',
        apellidos:'',
        edad:'',
        correo:'',
        pass:'',
        tipo_usuario:0,
        fecha_nacimiento: null,
        telefono:'',
				deleted:0,
				fecha_creacion:null,
      },

      // tabla
			search:'',
      usuarios: [],
      headers: [
        { text: 'ID usuarios'     , value: 'idusuarios'       },
        { text: 'Nombre completo' , value: 'nombre_completo'  },
        { text: 'Paquete'         , value: 'paquete'          },
        { text: 'Costo'           , value: 'costo'            },
        { text: 'Fecha Pago'      , value: 'fecha_pago'       },
        { text: 'Estatus'         , value: 'estatus'          },
        { text: 'FOLIO'           , value: 'idopenpay' },
        // { text: 'Fecha'           , value: 'fecha_nacimiento' },
        // { text: 'Actions'         , value: 'actions', sortable: false },
      ],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.usuarios = []
        return this.$http.get('historial.pagos').then(response=>{
        	this.usuarios = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.usuarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.usuarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('usuarios.update/' + this.editedItem.idusuarios, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	// Cargamos al usuario que hizo el cambio
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('usuarios.update/' + this.editedItem.idusuarios, this.editedItem).then(response=>{
          	this.validarSuccess( response.body.message )
          	this.initialize()
        		this.close()
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('usuarios.add', this.editedItem).then(response=>{
          	this.initialize()
	        	this.cargar = false
        		this.close()
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },
    },
  }
</script>


